import { GetOrigemLeadService } from "../../../Services/Repasse/OrigemLeadRepasse/OrigemLeadRepasseServices";
import { Controller } from "../../Controller";

export async function GetOrigemLeadController() {
    return Controller(GetOrigemLeadService());
}
